import { useStore } from 'vuex';

export default async function redirectToCompleteProfileMiddleware(to, from, next) {
  const store = useStore();
  const isLogged = store.getters['authentication/isLogged'];
  const user = store.getters['authentication/getUser'];

  if (isLogged && !user.registration_complete) {
    const data = await store.dispatch('profile/setProfileDetails');

    if (data.professions?.length > 0) {
      return next('/complete-profile');
    }
  }

  next();
}
